import { Box, Stack } from '@chakra-ui/react';
import { useRef, useEffect, useState } from 'react';
import { VirtualizedSiteList } from './VirtualizedSiteList';

// We use a few different APIs to get the list of sites, and they have slightly
// different shapes. So, they must conform to this to be rendered in the SitesList
export type SiteLocationType = {
  assigned: boolean;
  id: string;
  name: string;
  state: string | undefined | null;
  country: string | undefined | null;
  description: string | undefined | null;
  type: string | undefined | null;
  count: number | undefined | null;
};

export type SiteRegionType = {
  id: string;
  name: string;
  is_default: boolean;
};

export function SiteList({
  sites,
  region,
  toggleSiteAvailability,
}: {
  sites: SiteLocationType[];
  region?: SiteRegionType | undefined;
  toggleSiteAvailability: (site: SiteLocationType) => void;
}) {
  const parentRef = useRef<HTMLDivElement>(null);
  const [renderList, setRenderList] = useState(false);

  // For some reason we need to wait until we have a parentRef before we even
  // attempt to load the `VirtualizedSiteList`.
  useEffect(() => {
    if (parentRef.current) {
      setRenderList(true);
    }
  }, [parentRef]);

  return (
    <Stack flex="1" height="100%" bg="bg.canvas" px={4}>
      <Box ref={parentRef} height="calc(100% - 60px)" width={'full'} overflowY="auto">
        {renderList ? (
          <VirtualizedSiteList
            sites={sites}
            region={region}
            parentRef={parentRef}
            toggleSiteAvailability={toggleSiteAvailability}
          />
        ) : null}
      </Box>
    </Stack>
  );
}
